/**
 * Converts an image Blob to JPEG format using the Canvas API.
 * Works for any image format the browser can decode (webp, png, etc.).
 *
 * @param blob - Source image blob (any browser-decodable format)
 * @param quality - JPEG quality 0–1 (default 0.92)
 * @returns A new Blob of type image/jpeg
 */
export async function convertBlobToJpeg(blob: Blob, quality = 0.92): Promise<Blob> {
  const url = URL.createObjectURL(blob);
  try {
    const img = new Image();
    img.src = url;
    await img.decode();

    const canvas = document.createElement('canvas');
    canvas.width = img.naturalWidth;
    canvas.height = img.naturalHeight;

    const ctx = canvas.getContext('2d');
    if (!ctx) {
      throw new Error('Failed to get 2d canvas context');
    }
    ctx.drawImage(img, 0, 0);

    return await new Promise<Blob>((resolve, reject) => {
      canvas.toBlob(
        (result) => {
          if (result === null) {
            reject(new Error('Failed to convert image to JPEG'));
          } else {
            resolve(result);
          }
        },
        'image/jpeg',
        quality
      );
    });
  } finally {
    URL.revokeObjectURL(url);
  }
}
